import useFetchAndTrace from "../fetchWithTrace";
import settings from "../../../constants/settings";
import { useCustomAlert } from "../alerts";
import { MSLLevel } from "../../../components/component-search/PartDrawer/Inventory/PhysicalInventory/AddNewContainer";
interface PropertiesUpdateRequest {
  paste_in_hole: boolean;
  cannot_clean: boolean;
  moisture_sensitivity_level: MSLLevel | null;
}

export default function useUpdatePartProperties(partId: string | null) {
  const fetchAndTrace = useFetchAndTrace();
  const customAlert = useCustomAlert();

  const updatePasteInHoleHandler = async (response: Response) => {
    if (!response.ok) {
      throw new Error("Failed to update part specification.");
    }
  };

  const errorHandler = () => {
    customAlert("Failed to update part specification.");
  };
  const updatePartProperties = (partUpdateRequest: PropertiesUpdateRequest) => {
    if (partId === null) {
      return;
    }
    void fetchAndTrace(
      `${settings.api_url}/parts/${partId}/part-properties`,
      updatePasteInHoleHandler,
      errorHandler,
      {
        method: "PUT",
        body: JSON.stringify(partUpdateRequest),
      },
    );
  };

  return { updatePartProperties };
}
